
<ng-container *ngIf="this.viewType=='landscape'">
<div class="entity" [ngStyle]="{'background-color': statusColor}" (click)="editEntity()">

<ng-container *ngIf="pageView !== 1">
    <div matTooltip="Client Funded" *ngIf="data.clientfunded=='Yes'" class="top-left-badge">
        <fa-stack size="1x">
            <fa-icon icon="dollar-sign" stackItemSize="1x"></fa-icon>
            <fa-icon [icon]="['far', 'circle']" stackItemSize="2x" style="color:rgb(99, 255, 71,.9)"></fa-icon>
        </fa-stack>
    </div>
    
    <div matTooltip="Not Client Funded" *ngIf="data.clientfunded=='No'" class="top-left-badge">
        <fa-stack size="1x">
            <fa-icon icon="dollar-sign" stackItemSize="1x"></fa-icon>
            <fa-icon icon="ban" stackItemSize="2x" style="color:rgb(255, 99, 71,.9)"></fa-icon>
        </fa-stack>
    </div>
    
    <div matTooltip="Tenure Of Service" *ngIf="data.servicetenureNum" class="top-right-badge">{{data.servicetenureNum}}</div>
    <div *ngIf="data.yearslostNum" matTooltip="Years Lost" class="bottom-right-badge">{{ data.yearslostNum }}</div>
</ng-container>

    <div matTooltip="Service Name" class="servicename entity-box">{{data.servicename}}</div>

    <ng-container *ngIf="primaryTechnologyImage; else primaryTemplate1">
        <div [matTooltip]="'Primary Technology: ' + data.primarytechnology" class="primary entity-box" style="background-color: white !important;">
            <img class="image-fit" [src]="primaryTechnologyImage">
        </div>
    </ng-container>
    <ng-template #primaryTemplate1>
        <div [matTooltip]="data.primarytechnology ? ('Primary Technology: ' + data.primarytechnology) : ''" class="primary entity-box" [ngClass]="primaryTechnology === 'Client' ? 'clientlogo' : ''">
            <div class="entity-box-text">{{ primaryTechnology }}</div>
        </div>
    </ng-template>

    <ng-container *ngIf="secondaryTechnologyImage; else secondaryTemplate1">
        <div [matTooltip]="'Secondary Technology: ' + data.secondarytechnology" class="secondary entity-box" style="background-color: white !important;">
            <img class="image-fit" [src]="secondaryTechnologyImage">
        </div>
    </ng-container>
    <ng-template #secondaryTemplate1>
        <div [matTooltip]="data.secondarytechnology ? ('Secondary Technology: ' + data.secondarytechnology) : ''" class="secondary entity-box" [ngClass]="secondaryTechnology === 'Client' ? 'clientlogo' : ''">
            <div class="entity-box-text">{{ secondaryTechnology }}</div>
        </div>
    </ng-template>

    <ng-container *ngIf="providerImage; else providerTemplate1">
        <div [matTooltip]="'Service Provider: ' + data.provider" class="logo" style="background-color: white !important;">
            <img class="image-fit" [src]="providerImage">
        </div>
    </ng-container>
    <ng-template #providerTemplate1>
        <div [matTooltip]="data.provider ? ('Service Provider: ' + data.provider) : ''" class="logo entity-box" [ngClass]="provider === 'Client' ? 'clientlogo' : ''">
            <div class="entity-box-text">{{ provider }}</div>
        </div>
    </ng-template>
    <div matTooltip="Coverage %" class="coverage entity-box">{{fmtPrc(data.coverage)}}</div>
    <div matTooltip="EOL %" class="asset entity-box">{{fmtPrc(data.assetlifecycle)}}</div>
</div>
</ng-container>


<ng-container *ngIf="this.viewType=='health'">
    <div class="entity" [ngStyle]="{'background-color': statusColor}" (click)="editEntity()">

        <div matTooltip="Service Name" class="servicename entity-box">{{data.servicename}}</div>

        <ng-container *ngIf="primaryTechnologyImage; else primaryTemplate2">
            <div [matTooltip]="'Primary Technology: ' + data.primarytechnology" class="primary entity-box" style="background-color: white !important;">
                <img class="image-fit" [src]="primaryTechnologyImage">
            </div>
        </ng-container>
        <ng-template #primaryTemplate2>
            <div [matTooltip]="data.primarytechnology ? ('Primary Technology: ' + data.primarytechnology) : ''" class="primary entity-box" [ngClass]="primaryTechnology === 'Client' ? 'clientlogo' : ''">
                <div class="entity-box-text">{{ primaryTechnology }}</div>
            </div>
        </ng-template>

        <ng-container *ngIf="secondaryTechnologyImage; else secondaryTemplate2">
            <div [matTooltip]="'Secondary Technology: ' + data.secondarytechnology" class="secondary entity-box" style="background-color: white !important;">
                <img class="image-fit" [src]="secondaryTechnologyImage">
            </div>
        </ng-container>
        <ng-template #secondaryTemplate2>
            <div [matTooltip]="data.secondarytechnology ? ('Secondary Technology: ' + data.secondarytechnology) : ''" class="secondary entity-box" [ngClass]="secondaryTechnology === 'Client' ? 'clientlogo' : ''">
                <div class="entity-box-text">{{ secondaryTechnology }}</div>
            </div>
        </ng-template>

        <div [matTooltip]="'Health Trend - ' + data.healthtrend" class="logo">

            <fa-icon *ngIf="data.healthtrend=='Will Improve'" transform="rotate-45" size="3x" icon="arrow-circle-up" style="color:#97BE35"></fa-icon>
            <fa-icon *ngIf="data.healthtrend=='Will Maintain Healthy'" transform="rotate-90" size="3x" icon="arrow-circle-up" style="color:#97BE35"></fa-icon>
            <fa-icon *ngIf="data.healthtrend=='Will Degrade'" transform="rotate-90" size="3x" icon="arrow-circle-up" style="color:#F7CF2B"></fa-icon>
            <fa-icon *ngIf="data.healthtrend=='Is Actively Degrading'" transform="rotate-135" size="3x" icon="arrow-circle-up" style="color:#FF0000"></fa-icon>
            <fa-icon *ngIf="data.healthtrend=='Unknown Status'" size="3x" icon="question-circle" style="color:#A3A3A3"></fa-icon>
        </div>

        <div matTooltip="EOL %" class="coverage entity-box">{{fmtPrc(data.assetlifecycle)}}</div>
        <div matTooltip="EOSL %" class="asset entity-box">{{fmtPrc(data.healtheosl)}}</div>
    </div>
    </ng-container>
